/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const loggedInCheckinStyle = {
  formPaper: (theme: Theme) => ({
    padding: "1rem 2.5rem",
    [theme.breakpoints.down("md")]: {
      padding: "1rem",
    },
  }),
  heading: {
    textAlign: "center",
  },
  button: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      marginTop: "25px",
    },
  }),
  submit: {
    textAlign: "right",
  },
  default: {
  },
  grey: {
    backgroundColor: "background.contrast",
  },
  advantagesGridContainer: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "10px",
      marginBottom: "15px",
    },
  }),
  advantagesGridItems: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      padding: "0 !important",
    },
    /* Special Case Breakpoint */
    "@media (max-width: 750px)": {
      maxWidth: "100%",
      flexBasis: "100%",
    },
  }),
  advantagesContainer: (theme: Theme) => ({
    width: "fit-content",
    [theme.breakpoints.up("sm")]: {
      marginTop: "1rem",
      marginLeft: "auto",
      marginRight: "auto",
    },
  }),
  checkmark: {
    color: "primary.main",
    verticalAlign: "middle",
    fontSize: "2rem",
  },
  advantages: {
    verticalAlign: "sub",
  },
};

export default loggedInCheckinStyle;
